import * as S from "../CmpCargoInfoContent/cmpCargoInfoContent.styles";
import * as T from "../CmpCarInfoContent/cmpCarInfoContent.styles";

import { Button } from "../../../atoms/Buttons";
import { ReactComponent as IconCamera } from "../../../../styles/assets/svg/icon-camera.svg";
import { ReactComponent as IconUpload } from "../../../../styles/assets/svg/icon-upload.svg";
import { ReactComponent as IconLeftArrow } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRightArrow } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { useRef } from "react";
import { RefObject } from "react";

interface CmpCargoInsurInfoContentProps {
  onChangeImg: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  onSave: () => void;
  handleClick: () => any;
  imgRef: React.MutableRefObject<any>;
  imgFile: any;
  cameraRef: RefObject<HTMLInputElement>;
  onBackHandler: () => void;
}

export const CmpCargoInsurInfoContent = ({
  imgRef,
  cameraRef,
  onChangeImg,
  handleClick,
  onSave,
  imgFile,
  onBackHandler,
}: CmpCargoInsurInfoContentProps) => {
  return (
    <S.CmpInfoContentLayout>
      <T.CmpInfoHeader>
        <T.CmpInfoStep>
          <p>
            <span>9/9단계</span> 운송기사 자격등록
          </p>
        </T.CmpInfoStep>
        <S.CmpInfolongQuest>
          <span className="colorPrimary">적재물배상책임보험증서</span>을{" "}
          <p>등록해 주세요</p>
        </S.CmpInfolongQuest>
      </T.CmpInfoHeader>
      <S.ContentMainLayout>
        <S.CmpExplanBox>
          <p>모든 정보가 잘리지 않고 보여야 합니다.</p>
        </S.CmpExplanBox>
        {imgFile.length !== 0 ? (
          <S.CmpImgBox>
            <img
              src={
                imgFile[0].filename
                  ? `${process.env.REACT_APP_API_HOST}/user/driver-qualification/image/${imgFile[0].filename}`
                  : `${process.env.REACT_APP_API_HOST}${imgFile[0].imageUrl}`
              }
            />
          </S.CmpImgBox>
        ) : (
          <S.CmpCameraBox>
            <IconCamera id="icon-camera" fill="white" />
          </S.CmpCameraBox>
        )}

        <S.CmpUploadButton>
          <div className="row-buttons">
            <T.InputButton color="white" onClick={handleClick}>
              <IconUpload name="upload" width="24px" height="18px" />
              업로드
              <input
                ref={imgRef}
                type="file"
                accept="image/*"
                onChange={onChangeImg}
              />
            </T.InputButton>
            <T.InputButton color="white" onClick={handleClick}>
              <IconCamera
                name="upload"
                width="24px"
                height="18px"
                fill="#1D4ED7"
              />
              사진촬영
              <input
                id="cameraFile"
                ref={cameraRef}
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: "none" }}
              />
            </T.InputButton>
            {/* <Button
            type="button"
            color="white"
            size="full"
            onClick={onClickCamera}
          >
            <IconCamera
              name="camera"
              width="22px"
              height="20px"
              fill="#1D4ED7"
            />
            사진촬영
          </Button> */}
          </div>
        </S.CmpUploadButton>
      </S.ContentMainLayout>

      <T.CmpButtonBox>
        <div className="small">
          <Button
            type="button"
            color="transparent"
            size="full"
            onClick={onBackHandler} //지입계약서
          >
            <IconLeftArrow width={20} height={20} />
            이전
          </Button>
        </div>
        <Button
          type="button"
          size="full"
          onClick={onSave} //완료페이지
          disabled={imgFile.length !== 0 ? false : true}
        >
          다음
          <IconRightArrow width={20} height={20} />
        </Button>
      </T.CmpButtonBox>
    </S.CmpInfoContentLayout>
  );
};
